import React from 'react';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
} from '@nextui-org/react';
import { FiExternalLink, FiGithub } from 'react-icons/fi';

export default function NewCard({ list }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const tags = (list.tech || '').split(',').map((t) => t.trim()).filter(Boolean);

  return (
    <>
      <article
        className="glass proj-card is-clickable"
        role="button"
        tabIndex={0}
        aria-label={`${list.name} — view details`}
        onClick={onOpen}
        onKeyDown={(e) => {
          if (e.target.closest('a')) return;
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onOpen();
          }
        }}
      >
        <div className="proj-thumb">
          <img src={list.img} alt={list.name} loading="lazy" />
        </div>

        <div className="proj-body">
          <h3 className="proj-name">{list.name}</h3>
          <p className="proj-desc">{list.desc}</p>

          <div className="proj-tags">
            {tags.slice(0, 4).map((t) => (
              <span key={t} className="tag">
                {t}
              </span>
            ))}
            {tags.length > 4 && <span className="tag">+{tags.length - 4}</span>}
          </div>

          <div className="proj-actions">
            {list.git && (
              <a
                className="proj-action"
                href={list.git}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                <FiGithub /> Code
              </a>
            )}

            {list.link && (
              <a
                className="proj-action"
                href={list.link}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                <FiExternalLink /> Live
              </a>
            )}
          </div>
        </div>
      </article>

      <Modal
        backdrop="blur"
        isOpen={isOpen}
        onClose={onClose}
        size="2xl"
        scrollBehavior="inside"
        classNames={{ base: 'modal-x' }}
      >
        <ModalContent>
          {() => (
            <>
              <ModalHeader className="flex flex-col gap-1">
                <span>{list.name}</span>
                <span
                  style={{
                    fontSize: 13,
                    fontWeight: 400,
                    color: 'var(--text-muted)',
                  }}
                >
                  {list.tech}
                </span>
              </ModalHeader>

              <ModalBody>
                {(list.list || []).map((line) => (
                  <div key={line} className="modal-line">
                    <span className="modal-bullet">&#9656;</span>
                    <span>{line}</span>
                  </div>
                ))}
              </ModalBody>

              <ModalFooter>
                {list.git && (
                  <a
                    className="btn-ghost-x"
                    href={list.git}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FiGithub /> Code
                  </a>
                )}
                {list.link && (
                  <a
                    className="btn-primary-x"
                    href={list.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Visit <FiExternalLink />
                  </a>
                )}
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
